module.exports = __webpack_public_path__ + "static/media/Downer.a4d363e7.jpg";